import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MediaUnitDisplay } from "./Media";
import { fetchMediaItems, selectMediaById, selectMediaError, selectMediaStatus } from "./mediaSlice";
import Spinner from "../../components/Spinner";
import { useEffect } from "react";
import { selectCurrentUserAdmin } from "../currentUser/currentUserSlice";
import { EditMediaForm } from "./EditMediaForm";

const SingleMediaPage = () => {

    const dispatch = useDispatch();
    const mediaStatus = useSelector(selectMediaStatus);
    const mediaError = useSelector(selectMediaError);
    const isAdmin = useSelector(selectCurrentUserAdmin);

    useEffect(() => {
        if (mediaStatus === 'idle') {
            dispatch(fetchMediaItems());
        }
    }, [mediaStatus, dispatch]);

    const { itemId } = useParams();
    const item = useSelector(state => selectMediaById(state, itemId));

    return <>
        {mediaStatus === 'loading' && <Spinner />}
        {mediaStatus === 'failed' && <div>{mediaError}</div>}
        {mediaStatus === 'succeeded' && <div className="pagecontent">
            {!item && <h2>Item not found!</h2>}
            <MediaUnitDisplay mediaUnit={item} />
            {isAdmin && <EditMediaForm />}
        </div>}
    </>
}

export default SingleMediaPage;